import { h } from 'preact';
import './styles/Overlay.css';

export default function Overlay({ isOpen, children }) {
  return (
    <div
      className="beans-overlay"
      style={{
        display: `${isOpen ? 'grid' : 'none'}`,
      }}
    >
      {children}
    </div>
  );
}
